import { Radio } from 'antd';
import {
  profileOwnerTransferLabelMap,
  ProfileOwnerTransferOption,
} from 'models/user';
import React from 'react';
import styled from 'styled-components';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

interface ProfileOwnerTransferRadioOptionsProps {
  option?: ProfileOwnerTransferOption;
  setOption: React.Dispatch<
    React.SetStateAction<ProfileOwnerTransferOption | undefined>
  >;
}

const { Group } = Radio;

const StyledGroup = styled(Group)`
  margin-left: 1.3rem;
`;

const StyledRadio = styled(Radio)`
  display: block;
  height: 2.8125rem;
  line-height: 2.8125rem;
`;

export const ProfileOwnerTransferRadioOptions: React.FC<ProfileOwnerTransferRadioOptionsProps> = ({
  option,
  setOption,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <StyledGroup
      onChange={(e) => {
        setOption(e.target.value);
      }}
      value={option}
    >
      <StyledRadio value={ProfileOwnerTransferOption.WithProfiles}>
        {intlMessage({
          id: profileOwnerTransferLabelMap.get(
            ProfileOwnerTransferOption.WithProfiles
          ),
        })}
      </StyledRadio>
      <StyledRadio value={ProfileOwnerTransferOption.WithProfilesAndExams}>
        {intlMessage({
          id: profileOwnerTransferLabelMap.get(
            ProfileOwnerTransferOption.WithProfilesAndExams
          ),
        })}
      </StyledRadio>
    </StyledGroup>
  );
};
